import { createRequest } from "helpers/tools";

export const updateTrackerEvent = async (eventId, data) => {
  return await createRequest({
    suffix: `events/${eventId}`,
    method: "put",
    payload: data,
    handleError: false,
  });
};
